export interface ResourceCollision {
	resourceType: "extension" | "skill" | "agent" | "prompt" | "theme";
	name: string; // skill name, command/tool/flag name, prompt name, theme name
	winnerPath: string;
	loserPath: string;
	winnerSource?: string; // e.g., "npm:foo", "git:...", "local"
	loserSource?: string;
	// ponytail: explicit winner label so consumers don't string-compare winnerSource.
	winner?: "selesai" | "pi";
}

export interface ResourceDiagnostic {
	type: "warning" | "error" | "collision";
	message: string;
	path?: string;
	collision?: ResourceCollision;
}
